import { useState } from "react";
import { Button, Space, Table, Tag, message } from "antd";
import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";

import sdk from "@/sdk";
import { UserContract } from "@/graphql";
import { NoData } from "../../../../components/NoData";

export const UserContractsTab = ({ _id }: { _id: string }) => {
  const { data, isLoading } = useQuery({
    queryKey: ["userContracts", _id],
    queryFn: () => sdk.getUserContracts({ userId: _id }),
    select: (data) => data.userContracts,
    enabled: !!_id,
  });

  const [loadingContract, setLoadingContract] = useState<string | null>(null);

  const openContract = async (contractName: string, download: boolean) => {
    try {
      setLoadingContract(contractName);
      const { userContractUrl } = await sdk.getUserContractUrl({
        userId: _id,
        contractName,
      });
      if (download) {
        const a = document.createElement("a");
        a.href = userContractUrl;
        a.download = `${contractName}.pdf`;
        a.click();
      } else {
        window.open(userContractUrl, "_blank");
      }
    } catch {
      message.error("Гэрээ татахад алдаа гарлаа");
    } finally {
      setLoadingContract(null);
    }
  };

  if (!isLoading && (!data || data.length === 0)) {
    return (
      <div className="detail-widget-container">
        <NoData />
      </div>
    );
  }

  return (
    <div className="detail-widget-container">
      <div className="detail-widget-container-content">
        <Table
          loading={isLoading}
          dataSource={data}
          rowKey="_id"
          size="small"
          bordered
          columns={[
            {
              title: "Гэрээний нэр",
              dataIndex: "contractName",
            },
            {
              title: "Гэрээний дугаар",
              dataIndex: "contractNo",
            },
            {
              title: "Version",
              dataIndex: "version",
              render: (v: number) => <Tag color="blue">v{v}</Tag>,
            },
            {
              title: "Зурсан огноо",
              dataIndex: "signedAt",
              render: (value: string) =>
                moment(value).format("YYYY.MM.DD HH:mm"),
            },
            {
              title: "",
              dataIndex: "actions",
              render: (_: unknown, record: UserContract) => (
                <Space>
                  <Button
                    type="link"
                    icon={<EyeOutlined />}
                    loading={loadingContract === record.contractName}
                    onClick={() => openContract(record.contractName, false)}
                  >
                    Харах
                  </Button>
                  <Button
                    type="link"
                    icon={<DownloadOutlined />}
                    loading={loadingContract === record.contractName}
                    onClick={() => openContract(record.contractName, true)}
                  >
                    Татах
                  </Button>
                </Space>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};
